'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import ProdutoPaginaMobile from './Designs/Mobile';
import ProdutoPaginaDesktop from './Designs/Desktop';
import { useRouter } from 'next/navigation';
import useProdutoPageHook from './hook/useProdutoPageHook';

export type ProdutoPaginaProps = {
  $produtoSlug: string;
};

export default function ProdutoPagina(props: ProdutoPaginaProps) {
  const { breakpoint } = useBreakpoint();
  const router = useRouter();

  const propsProdutoPagina = useProdutoPageHook(props.$produtoSlug, router);

  return breakpoint === 'mobile' ? (
    <ProdutoPaginaMobile {...propsProdutoPagina} />
  ) : (
    <ProdutoPaginaDesktop {...propsProdutoPagina} />
  );
}
